// extracted by mini-css-extract-plugin
export default {"root":"Search_root__vnaf2","input":"Search_input__bz7qC","icon":"Search_icon__YPgkJ","iconClear":"Search_iconClear__JRYR3"};